import * as React from 'react'


export default class FormGroup extends React.Component<any, any>{

    render(){
        const field = this.props.field;
        const errors = this.props.errors;

        const hasDanger = errors && errors.length > 0;
        const hasSuccess = errors && errors.length == 0
        const className = "form-group " + (hasDanger ? " has-danger" : "") + (hasSuccess ? " has-success" : "") + (this.props.className ? " " + this.props.className : "") ;
        
        return (
            <div id={ "form-group-" + field.replace(".", "-") } className={ className }>
                { this.props.children }
            </div>
        )
    }


}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/form-group.tsx